<div class="landing">

    <a *ngFor="let key of productKeys" class="product" routerLink="/product/{{key}}">
      <mat-card class="product-card">
        <mat-card-header><h1>{{products[key].name }}</h1></mat-card-header>
        <img mat-card-image [src]="products[key].image">
      </mat-card>
    </a>
  </div>
